import { render } from "react-dom";
import React from "react";
import BasketSummary from "./basket/components/basket_summary";
render(React.createElement(BasketSummary), document.querySelector(".basket-overview"));
